import '../../scss/acf-blocks/acfb-modal.scss';

const FOCUSABLE_SELECTORS = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

function getPageMain() {
	return document.querySelector('#page, .site, main, #main') || document.body;
}

function createFocusTrap(container) {
	const handler = (e) => {
		if (e.key !== 'Tab') return;
		const focusable = Array.from(container.querySelectorAll(FOCUSABLE_SELECTORS));
		if (focusable.length === 0) return;
		const first = focusable[0];
		const last = focusable[focusable.length - 1];
		if (e.shiftKey) {
			if (document.activeElement === first) { e.preventDefault(); last.focus(); }
		} else {
			if (document.activeElement === last) { e.preventDefault(); first.focus(); }
		}
	};
	document.addEventListener('keydown', handler);
	return () => document.removeEventListener('keydown', handler);
}

/**
 * Initialize modal video functionality
 * Opens modal on cover click, closes on close button or overlay click
 * Autoplay video when modal opens
 */
function initModalVideo() {
	const modalContainers = document.querySelectorAll('.modal-video');

	modalContainers.forEach((container) => {
		const body = document.body;
		const modal = container.querySelector('.modal');
		const closeBtn = container.querySelector('.modal__close');
		const trigger = container.querySelector('.modal-video__trigger');
		const iframe = container.querySelector('.modal__content iframe');

		if (!modal || !trigger) return;

		// Salva l'src originale (senza autoplay) una sola volta, cosi' stopVideo
		// puo' sempre ripristinarlo esattamente com'era, invece di manipolare
		// la query string ogni volta (fragile su URL con parametri diversi).
		if (iframe) iframe.dataset.baseSrc = iframe.getAttribute('src') || '';

		const pageMain = getPageMain();
		let lastFocusedElement = null;
		let removeFocusTrap = null;

		const openModal = (triggerEl = null) => {
			lastFocusedElement = triggerEl || document.activeElement;
			body.classList.add('modal-open');
			modal.classList.add('is-open');
			pageMain.setAttribute('aria-hidden', 'true');
			const focusable = modal.querySelectorAll(FOCUSABLE_SELECTORS);
			if (focusable.length) focusable[0].focus();
			removeFocusTrap = createFocusTrap(modal);
			if (iframe) playVideo(iframe);
		};

		const closeModal = () => {
			modal.classList.remove('is-open');
			body.classList.remove('modal-open');
			pageMain.removeAttribute('aria-hidden');
			if (removeFocusTrap) { removeFocusTrap(); removeFocusTrap = null; }
			if (lastFocusedElement) { lastFocusedElement.focus(); lastFocusedElement = null; }
			if (iframe) stopVideo(iframe);
		};

		// Open modal on cover trigger click
		trigger.addEventListener('click', (e) => {
			e.preventDefault();
			openModal(e.currentTarget);
		});

		// Close modal on close button click
		if (closeBtn) {
			closeBtn.addEventListener('click', (e) => {
				e.stopPropagation();
				closeModal();
			});
		}

		// Close modal on overlay click
		modal.addEventListener('click', (e) => {
			if (e.target === modal) {
				closeModal();
			}
		});

		// Close modal on Escape key
		const handleEscape = (e) => {
			if (e.key === 'Escape' && modal.classList.contains('is-open')) {
				closeModal();
			}
		};
		document.addEventListener('keydown', handleEscape);
	});
}

/**
 * Start video playback by adding autoplay parameter to iframe src
 * @param {HTMLElement} iframe - The iframe element
 */
function playVideo(iframe) {
	const baseSrc = iframe && iframe.dataset.baseSrc;
	if (!baseSrc) return;

	// If YouTube video, add autoplay=1 to the URL
	if (baseSrc.includes('youtube')) {
		const separator = baseSrc.includes('?') ? '&' : '?';
		iframe.src = baseSrc + separator + 'autoplay=1';
	}
}

/**
 * Stop video playback by unloading the iframe (src = about:blank). This is
 * the reliable way to force-stop an embedded YouTube player: toggling just
 * the autoplay query param isn't always enough to actually kill playback in
 * every browser. The original src is kept in dataset.baseSrc so playVideo
 * can rebuild it fresh on the next open.
 * @param {HTMLElement} iframe - The iframe element
 */
function stopVideo(iframe) {
	if (!iframe || 'about:blank' === iframe.src) return;

	iframe.src = 'about:blank';
}

document.addEventListener('DOMContentLoaded', initModalVideo);

